<sub-header [isModal]="true" [includeContextHelp]="false" [windowHash]="windowHash">
</sub-header>
<documentViewer [documentIdParam]="documentIdentifiers[index]"></documentViewer>